import { useContext } from "react"
import { Field } from "formik"
import { DateTime } from "luxon"
import _ from "lodash"

import { FormContext } from "../../../context/formContext"
import { Calendar } from "primereact/calendar"

import styles from "../../../styles/Form.module.css"
import fieldVisibility from "../../../helpers/fieldVisibility"

export default function TypeDemoBirthdate({ field, block, index }) {
  const form = useContext(FormContext)
  const isDisabled = form ? form.blocksSaved[block] : false
  const checkIfRequired = () => {
    try {
      return JSON.parse(field.field_validation.required[0])
    } catch (error) {
      return false
    }
  }
  const isRequired = checkIfRequired()

  const now = DateTime.now()
  const handleMinDate = () => {
    const minAge = now.minus({ years: 101 })
        return minAge.toJSDate()
  }
  const handleMaxDate = () => {
    const maxAge = now.minus({ years: 12 })
    return maxAge.toJSDate()
  }

  return (
    <div
      className={styles.field}
      style={{
        order: index,
        display: fieldVisibility(field.field_visibility),
      }}
    >
      <label className={styles.label}>
        {field.field_label}
        {isRequired && "*"}
      </label>
      {field.field_description && (
        <div className={styles.description}>{field.field_description}</div>
      )}
      <Field name={field.field_name}>
        {({ field: formikField, meta }) => {
          let birthdate = ""

          if (_.isDate(formikField.value)) {
            let timestamp = formikField.value
            if (timestamp?._seconds) {
              const jsDate = DateTime.fromJSDate(timestamp?._seconds).toFormat('yyyy-MM-dd')
              birthdate = DateTime.fromISO(jsDate + 'T12:00:00.000', {zone: 'utc'}).toJSDate()
            } else {
              const jsDate = DateTime.fromJSDate(formikField.value).toFormat('yyyy-MM-dd')
              birthdate = DateTime.fromISO(jsDate + 'T12:00:00.000', {zone: 'utc'}).toJSDate()
            }
          }

          return (
            <>
              <Calendar
                name={formikField.name}
                value={birthdate}
                onChange={formikField.onChange}
                disabled={isDisabled}
                onBlur={formikField.onBlur}
                maxDate={handleMaxDate()}
                minDate={handleMinDate()}
              />
              {meta.touched && meta.error && (
                <div className={styles.errFieldMsg}>{meta.error}</div>
              )}
            </>
          )
        }}
      </Field>
    </div>
  )
}
